import * as React from 'react';

import { Api } from '../../typings/api';
import { ListDisplayType } from '../../containers/DriveItemList/constants';
import { LoaderStep } from '../Loader';
import DriveItemUtils, { ThumbnailDescriptor } from '../../utils/driveItem';
import ListItem from '../ListItem';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import UserAgentUtils from '../../utils/userAgent';
import { createNotification } from '../../containers/NotificationBar/actions';
import { viewDriveItem, DriveItemOrigin } from '../../containers/DriveItemList/actions';

interface DriveItemProps {
	driveItem: Api.DriveItem;
	showUnreadBadge: boolean;
	displayType: ListDisplayType;
	dispatch: Dispatch<StoreState>;
	isSelectedForContextualMenu: boolean;
	isDownloading: boolean;
	isDownloaded: boolean;
	loaderStep: LoaderStep | undefined;
	thumbnailDescriptor: ThumbnailDescriptor;
	isUnread: boolean;
	isEditMode: boolean;
	hasActions?: boolean;
	hasSelectionIcon?: boolean;
	onClick?: () => void;
	isDraggable?: boolean;
	index?: number;
	itemsCount?: number;
	isDragPreview?: boolean;
}

const DriveItem = ({
	driveItem,
	showUnreadBadge,
	displayType,
	dispatch,
	isSelectedForContextualMenu,
	isDownloading,
	isDownloaded,
	loaderStep,
	thumbnailDescriptor,
	isUnread,
	isDraggable,
	index,
	hasActions = true,
	hasSelectionIcon = true,
	onClick,
	itemsCount,
	isDragPreview,
	isEditMode,
}: DriveItemProps) => {
	const handleClick = () => {
		if (onClick) {
			return onClick();
		}

		const isOnline = UserAgentUtils.isOnline();

		if (!isDownloading) {
			const isDirectory = driveItem.type === Api.DriveItemType.Directory;
			const isImage = driveItem.type === Api.DriveItemType.Image;
			const alwaysViewable = isDirectory || isImage;
			const isNotViewable = !isOnline && !isDownloaded && !alwaysViewable;
			if (isNotViewable) {
				dispatch(createNotification('info.offline_download_single_asset'));
				return;
			}

			dispatch(viewDriveItem(driveItem, DriveItemOrigin.List));
		}
	};

	return (
		<ListItem
			onClick={handleClick}
			showUnreadBadge={showUnreadBadge}
			displayType={displayType}
			driveItemType={driveItem.type}
			driveItemId={driveItem.id}
			hasActionButton={hasActions}
			hasSelectionIcon={hasSelectionIcon}
			label={DriveItemUtils.getDisplayName(driveItem)}
			isSelectedForContextualMenu={isSelectedForContextualMenu}
			isDownloading={isDownloading}
			isDownloaded={isDownloaded}
			loaderStep={loaderStep}
			thumbnailDescriptor={thumbnailDescriptor}
			isUnread={isUnread}
			isEditMode={isEditMode}
			isDraggable={isEditMode && isDraggable}
			index={index}
			driveItem={driveItem}
			itemsCount={itemsCount}
			isDragPreview={isDragPreview}
		/>
	);
};

export default DriveItem;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItem/index.tsx